module.exports = __webpack_public_path__ + "static/media/logo_nav.278e9ed7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_nav.svg
// module id = 644
// module chunks = 0